import { useEffect, useMemo } from 'react';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { IS_IOS, IS_SAFARI, LINK_APP_STORE, LINK_GOOGLE_PLAY } from './config';
import { Link } from '@mui/material';

const AppInstructions = () => {
    
    const labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    theme = useTheme(),
    isMobile = useMediaQuery( theme.breakpoints.down('md') ),
    { enqueueSnackbar } = useSnackbar();

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    // alert the user to limit mobile functionality outside metamask browser
    useEffect(() => {
        if( isMobile && !window.ethereum ){
            enqueueSnackbar(
                labels.formatString(
                    labels.mobile,
                    <>
                        {
                            IS_IOS ?
                                <Link href={ LINK_APP_STORE }>{ labels.appStore }</Link> :
                                <Link href={ LINK_GOOGLE_PLAY }>{ labels.googlePlay }</Link>
                        }
                    </>
                ),
                { 
                    variant: 'warning', 
                    persist: true,
                    key: 'mobile'
                }
            );
        } else if( IS_SAFARI ){
            enqueueSnackbar(
                labels.safari,
                { variant: 'warning', persist: true, key: 'safari' }
            );
        }
    }, [ enqueueSnackbar, isMobile, labels ]);

    return null;

}

export default AppInstructions;